<ng-container>
    <shipper-bi-embed tag="RAILTRAC Home" #reportContainer> </shipper-bi-embed>
</ng-container>
<ng-container *ngIf="!isLoaded">
    <div class="splash-wrapper">
        <div class="splash-positioner mat-elevation-z24">
            <div class="splash"></div>
        </div>
    </div>
</ng-container>
